// A chip tags; it never acts. Honey for the next step, blue for a source,
// grey for optional, green for synced.
import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';
import { cx } from './cx';

export interface ChipProps { tone?: 'honey' | 'blue' | 'grey' | 'green'; icon?: IconName; className?: string; children: ReactNode }

export function Chip({ tone = 'honey', icon, className, children }: ChipProps) {
  return (
    <span className={cx('chip', tone !== 'honey' && tone, className)}>
      {icon && <Icon name={icon} />}
      {children}
    </span>
  );
}
